module.exports = __webpack_public_path__ + "static/media/showerRect90.7103660c.png";